import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { AxiosError } from 'axios';

export const fetchCustomer = async (query) => {
  const { data } = await apiClient.get(`/customers/${query.queryKey[1]}`);
  return data;
};

export const useGetCustomerHandler = (id) => {
  const dispatch = useDispatch();
  const [customer, setCustomer] = useState(undefined);

  const {
    data: fetchedData,
    isLoading,
    isFetching,
    isError,
    error,
  } = useQuery({
    queryKey: ['customers', id], // A unique key for this query
    queryFn: fetchCustomer,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
    retry: 3,
  });

  useEffect(() => {
    if (fetchedData) {
      setCustomer(fetchedData);
    }
  }, [fetchedData]);

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        if (error.status) {
          dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
        } else {
          dispatch(showSnackbar({ message: error.message, severity: 'error' }));
        }
      } else {
        dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
      }
    }
  }, [dispatch, error, isError]);

  return {
    customer,
    isLoading,
  };
};
